import { showErrorToast } from './showErrorToast';

/**
 * Shows a standardized toast for map load failures.
 *
 * Call this from the map component's onError/onLoadError handler.
 * When a real map provider is wired, replace the TODO below with the
 * actual error event callback:
 *
 *   mapInstance.on('error', () => showMapLoadErrorToast());
 */
export function showMapLoadErrorToast(): void {
    showErrorToast({
        code: 'map_load_failed',
        title: 'Something went wrong',
        message: "That didn't work. Please try again.",
    });
}
